<template>
  <div
    :class="{'blocks-right__empty': isOfferLoading && !isList}"
    class="blocks-right offer-info-block"
  >
    <p v-if="isOfferLoading && !isList">
      {{ $t('affiliates.affiliatesOffers.offer_detail') }}
    </p>
    <div
      v-if="isOfferLoading && isList && hasOffers"
      class="offer-card offer-card__cling-up"
    >
      <div class="offer-card__up-border offer-card__up t:flex-col">
        <div class="t:flex t:justify-between">
          <div>
            <div class="offer-card__header">
              <span><span class="offer-card__text-gray">ID: </span>{{ offerInfo.incrementing_id || '' }}</span>
              <template v-if="offerInfo.catalog_category_name || offerInfo.category_name">
                <div class="offer-card__separator t:mr-8 t:ml-8" />
                <span>
                  <span class="offer-card__text-gray">{{ $t('affiliates.offersCategory.category') }}:</span>
                  {{ offerInfo.catalog_category_name || offerInfo.category_name }}
                </span>
              </template>
              <template v-else-if="!offerInfo.cataloged_affiliate_offer_id">
                <div class="offer-card__separator t:mr-8 t:ml-8" />
                <div class="t:flex t:items-center">
                  <UiIcon
                    name="gear"
                    substyle="far"
                    color="var(--text-primary)"
                  />
                  &nbsp;
                  <span class="offer-card__text-success">{{ $t('affiliates.affiliatesOffers.custom_offer') }}</span>
                </div>
              </template>
            </div>

            <h4 class="offer-card__title-inner">
              {{ offerInfo.name }}
            </h4>
          </div>
          <div class="tech-wrapper">
            <div
              v-if="offerInfo.scheduled_offer_settings"
              class="pending-changes-info"
              v-html="$t('affiliates.affiliatesOffers.pending_date', {date: pendingChangesDate})"
            />
            <div class="offer-card__down-btns">
              <UiButton
                v-if="isDeleteOffer"
                :loading="loadingBtn"
                type="negative"
                class="btn-red"
                icon="unlink"
                @click="checkUnpin"
              >
                {{ $t('affiliates.affiliatesOffers.unpin') }}
              </UiButton>
              <UiButton
                v-if="isEditOffer"
                class="action-btn"
                icon="pen"
                @click="editOffer(offerInfo.scheduled_changes_effective_timestamp !== null)"
              >
                {{ $t('affiliates.affiliatesOffers.edit') }}
              </UiButton>
            </div>
          </div>
        </div>

        <div
          v-if="offerInfo.cataloged_affiliate_offer_description || offerInfo.description"
          class="offer-card__description"
        >
          {{ offerInfo.cataloged_affiliate_offer_description || offerInfo.description }}
        </div>
      </div>
      <div class="t:flex t:flex-col">
        <div class="title-blue brands t:flex t:justify-between">
          {{ isDiff ? $t('affiliates.affiliatesOffers.available_brands') : $t('affiliates.affiliatesOffers.available_brands_links') }}
          <div
            v-if="!isDiff"
            v-clipboard="() => formattedLinks"
            v-clipboard:success="onCopySuccess"
            v-clipboard:error="onCopyError"
            class="t:flex copy-links"
          >
            <UiIcon
              name="copy"
              color="inherit"
              class="t:mr-4"
            />
            {{ $t('affiliates.affiliatesOffers.copyLinks') }}
          </div>
        </div>
        <div class="title-blue t:flex offer-card__brands">
          <div
            v-for="item in availableBrands(offerInfo.brand_visibility, offerInfo.visible_brands)"
            :key="item.id"
            class="brands-item-info"
            :class="{'active': !isDiff && item.id === currentOfferCardBrand, 'pending': isDiff}"
            @click="onSelectBrand(item.id)"
          >
            <img
              v-if="item.favicon_base64"
              :src="item.favicon_base64"
            >
            {{ item.name }}
          </div>
        </div>
        <div class="t:mt-8 links">
          <div
            v-for="(tracking_links, index) in offerInfo.tracking_links"
            :key="index"
            class="t:w-full offer-card__table"
          >
            <div
              v-for="(item, ind) in filterOfferUrls(tracking_links.urls)"
              :key="ind"
              class="offer-card__table-row"
            >
              <div
                class="offer-card__down-item link"
              >
                <h5 class="offer-card__title-inner">
                  {{ item.name }}
                </h5>
                <span class="text-tooltip text-tooltip__viridian">{{ item.url }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="isOfferLoading && isList && offerInfo"
      class="offer-card offer-card__cling-down"
    >
      <div class="offer-card__left">
        <h5 class="offer-card__title-inner condition">
          {{ $t('affiliates.affiliatesOffers.rule_candiion') }}
        </h5>
        <UiInput
          v-model="searchText"
          is-search
          autosize
          @search="searchRule"
        />
        <div v-if="rulesList.length !== 0">
          <div
            v-for="(item, index) in rulesList"
            :key="index"
            class="title-blue__wrap"
            @click="isActiveRule = index"
          >
            <div
              :class="{'title-blue__active': isActiveRule === index}"
              class="title-blue"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="offer-card__right">
        <!-- Country -->
        <OfferRulesContent
          :rules-list="rulesList"
          :is-active-rule="isActiveRule"
          :offer-info="offerInfo"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Vnodes from '@/components/VNodes.vue';
import OfferRulesContent from './OfferRulesContent.vue';

export default {
  name: 'OfferInfo',

  components: {
    OfferRulesContent,
    Vnodes,
  },

  props: {
    isOfferLoading: {
      type: Boolean,
      default() {
        return true;
      },
    },
    isList: {
      type: Boolean,
      default() {
        return true;
      },
    },
    isEditOffer: {
      type: Boolean,
      default() {
        return true;
      },
    },
    isDeleteOffer: {
      type: Boolean,
      default() {
        return true;
      },
    },
    loadingBtn: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isDiff: {
      type: Boolean,
      default() {
        return false;
      },
    },
    offerInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      currentOfferCardBrand: '',
      searchText: '',
      rulesList: [],
      isActiveRule: 0,

      hiddenCasino: 1,
      hiddenSport: 1,
      hiddenDeposits: 1,
    };
  },

  computed: {
    ...mapGetters({
      brands: 'misc/brands',
    }),
    hasOffers() {
      return !this.$_.isEmpty(this.offerInfo);
    },

    pendingChangesDate() {
      return this.$filters.formatDate3(this.offerInfo.scheduled_changes_effective_timestamp);
    },

    formattedLinks() {
      return !this.isDiff ? this.$_.join(
        this.offerInfo.tracking_links[0].urls.filter((rule) => rule.site_id === this.currentOfferCardBrand)
          .map((item) => `${item.url} - ${item.name_short}`),
        '\n',
      ) : '';
    },
  },

  watch: {
    offerInfo() {
      this.defaultBrandsSelectValue();
      this.rulesList = this.offerInfo.payout_rules.map((rule, i) => {
        const { values, displayValues } = this.getOfferName(this.offerInfo.payout_rules, i, 46);
        return {
          ...rule,
          name: displayValues,
          values,
        };
      });
      this.isActiveRule = 0;
      this.searchText = '';
    },
  },

  mounted() {
    if (this.hasOffers) {
      this.defaultBrandsSelectValue();
      this.rulesList = this.offerInfo.payout_rules.map((rule, i) => {
        const { values, displayValues } = this.getOfferName(this.offerInfo.payout_rules, i, 46);
        return {
          ...rule,
          name: displayValues,
          values,
        };
      });
    }

    this.isActiveRule = 0;
    this.searchText = '';
  },

  methods: {
    onSelectBrand(id) {
      if (this.isShowOfferLinksSelect()) {
        this.currentOfferCardBrand = id;
      }
    },

    countryPartName(rules, index, rowLen) {
      const prefix = this.prefixName(rules, index);
      const values = rules[index].filters?.country_code || [];

      if (!values?.length) {
        return {
          values: prefix,
          displayValues: prefix,
        };
      }

      const fitValues = this.$_.truncate(values.join(', '), {
        length: rowLen - prefix.length,
        separator: ', ',
        omission: '',
      });

      const notFit = values.filter((val) => !fitValues.split(', ').includes(val));
      const countNotFit = notFit.length ? ` [+${notFit.length}]` : '';
      return {
        values: `${prefix} ${values.join(', ')}`,
        displayValues: `${prefix} ${fitValues}${countNotFit}`,
      };
    },
    isEmptyRs(lvl) {
      if (!lvl) return true;

      return lvl.every((el) => !+el.percent);
    },
    prefixName(rules, index) {
      const { rev_share, cpa } = rules[index].settings;

      if (
        [
          rev_share?.sport_levels,
          rev_share?.casino_levels,
        ].every(this.isEmptyRs) && cpa && cpa.some((el) => el.amount > 0)
      ) {
        return '[CPA] ';
      }

      if (rev_share && cpa) {
        return '[Hyb] ';
      }

      if (rev_share) {
        return '[RS] ';
      }

      if (cpa) {
        return '[CPA] ';
      }

      return '';
    },
    getOfferName(rules, index, rowLen) {
      if (index === rules.length - 1) {
        return {
          values: 'Default',
          displayValues: 'Default',
        };
      }

      return this.countryPartName(rules, index, rowLen);
    },

    defaultBrandsSelectValue() {
      this.currentOfferCardBrand = this.hasOffers ? this.availableBrands(this.offerInfo.brand_visibility, this.offerInfo.visible_brands)[0].id : '';
    },

    availableBrands(visibility, offerBrands) {
      if (visibility !== 'all') {
        const formatedBrands = [];
        offerBrands.forEach((brand) => {
          formatedBrands.push({
            id: brand.site_id,
            name: brand.site_name,
            favicon_base64: brand.site_favicon,
          });
        });
        return formatedBrands;
      }
      return this.brands;
    },

    getBrandImgUrl() {
      const brandFavicon = this.currentOfferCardBrand.length !== 0 ? this.brands.filter((brand) => brand.id === this.currentOfferCardBrand)[0].favicon_base64 : '';
      return brandFavicon !== undefined ? brandFavicon : '';
    },

    isShowOfferLinksSelect() {
      return !(this.offerInfo.brand_visibility !== 'all' && this.offerInfo.visible_brands.length === 1);
    },

    filterOfferUrls(urls) {
      return urls.filter((rule) => rule.site_id === this.currentOfferCardBrand);
    },

    onCopyError() {
      this.$eventBus.$emit('notify-event', {
        type: 'error',
        text: this.$t('affiliates.affiliatesOffers.failedCopyLink'),
      });
    },

    onCopySuccess() {
      this.$eventBus.$emit('notify-event', {
        type: 'info',
        text: this.$t('affiliates.affiliatesOffers.copiedClipboard'),
      });
    },

    searchRule(v) {
      this.isActiveRule = 0;
      this.rulesList = this.offerInfo.payout_rules.map((rule, i) => {
        const { values, displayValues } = this.getOfferName(this.offerInfo.payout_rules, i, 50);
        return {
          ...rule,
          name: displayValues,
          values,
        };
      });
      this.rulesList = this.rulesList.filter((e) => e.values.replaceAll(' ', '').toLowerCase().indexOf(v.replaceAll(' ', '').toLowerCase()) !== -1);
    },

    checkUnpin() {
      this.$eventBus.$emit('checkUnpin');
    },

    editOffer(scheduled_hanges) {
      this.$eventBus.$emit('editOffer', scheduled_hanges);
    },
  },
};
</script>

<style lang="scss" scoped>
.copy-links {
  cursor: pointer;
  font-size: 13px;
  font-weight: 400;
}
</style>
